import { useRouter } from '#app/hooks/useRouter.js';
import { type To } from '#app/types/router.js';

export const useExactMatch = (location: To, exact: boolean = true) => {
  const { isActive } = useRouter();

  return isActive(location, exact);
};
